var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"chat-content",staticStyle:{"position":"absolute","height":"100%","width":"100%","border":"0px","padding-top":"1px"},attrs:{"id":"chat","src":_vm.theLoungeUri}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e51bdbd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Chat.vue
// module id = 389
// module chunks = 0